module.exports = __webpack_public_path__ + "static/media/S (186).cc760648.jpg";